import { render, staticRenderFns } from "./CheckForm.vue?vue&type=template&id=6bf81c64&scoped=true&"
import script from "./CheckForm.vue?vue&type=script&lang=js&"
export * from "./CheckForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckForm.vue?vue&type=style&index=0&id=6bf81c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf81c64",
  null
  
)

export default component.exports